// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconDevicePhone = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M40 8H24C19.0637 8 16 11.0637 16 16V48C16 52.9363 19.0637 56 24 56H40C44.9363 56 48 52.9363 48 48V16C48 11.0637 44.9363 8 40 8ZM38 50H26C24.771 50 24 49.2289 24 48C24 46.771 24.771 46 26 46H38C39.229 46 40 46.771 40 48C40 49.2289 39.229 50 38 50Z" />
    </svg>
  );
};
